export function createWikiApi(http, backendurl) {
  const base = `${backendurl}api/v1/wiki`
  return {
    list: () => http.get(`${base}/articles`),
    get: slug => http.get(`${base}/articles/${encodeURIComponent(slug)}`),
    search: query => http.get(`${base}/search`, { params: { q: query } }),
    create: payload => http.post(`${base}/admin/articles`, payload),
    update: (id, version, payload) => http.put(`${base}/admin/articles/${id}`, payload, { headers: { 'If-Match': `"${version}"` } }),
    remove: id => http.delete(`${base}/admin/articles/${id}`),
    reorder: ids => http.put(`${base}/admin/order`, { article_ids: ids }),
    uploadAsset: file => {
      const form = new FormData(); form.append('file', file)
      return http.post(`${base}/admin/assets`, form, { headers: { 'Content-Type': 'multipart/form-data' } })
    },
  }
}
